import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  ConfigurationDto,
  ConfigurationUpdateRequestDto,
} from 'lib_api/lib/api/gen';

import { FetchDataResult } from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

import { configurationQueryKeyLabel } from '../../labels';

import { computeNewData } from './updateUtils';

export function useConfigurationMutation(
  configuration: ConfigurationDto,
  closeModal: () => void,
) {
  const { AdminFonctionnelControllerApi: controller } = useApi();
  const queryClient = useQueryClient();

  const mutationFn = (newValues: ConfigurationUpdateRequestDto) =>
    controller.updateConfigurationUsingPUT(
      configuration.idCorrelation,
      newValues,
    );

  const onSuccess = (mutationResult: ConfigurationDto) => {
    queryClient.setQueriesData(
      { queryKey: [configurationQueryKeyLabel] },
      (oldData: FetchDataResult<ConfigurationDto>) =>
        computeNewData(oldData, mutationResult),
    );
  };

  const onError = (error: Response) => {
    void queryClient.invalidateQueries({
      queryKey: [configurationQueryKeyLabel],
    });
    void backAlertMessage(error);
  };

  return useMutation({
    mutationFn,
    onSuccess,
    onSettled: closeModal,
    onError,
  });
}
